import { render, staticRenderFns } from "./StepPrivacyAgreement.vue?vue&type=template&id=8d06cdc4"
import script from "./StepPrivacyAgreement.vue?vue&type=script&lang=js"
export * from "./StepPrivacyAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports